import React from 'react'
import PropTypes from 'prop-types'

import Tab from './Tab'

class NavTab extends React.Component {
  static propTypes = {
    /* Custom classnames */
    className: PropTypes.string,
    /* One or more Tab elements */
    children: PropTypes.oneOfType([PropTypes.arrayOf.node, PropTypes.node])
      .isRequired,
    /* Initial tab visible (0,1,2...) */
    defaultTab: PropTypes.number,
    /* OnChange event */
    onChange: PropTypes.func,
  }

  state = {
    currentTab: 0,
  }

  componentDidMount() {
    const { children } = this.props

    if (
      !children ||
      (Array.isArray(children) &&
        children.filter((node) => node.type === Tab).length === 0) ||
      (!Array.isArray(children) && children.type !== Tab)
    ) {
      throw new Error('No valid tabs to NavTab component')
    }

    this.checkDefaultTab()
  }

  checkDefaultTab() {
    const { defaultTab } = this.props

    if (defaultTab) {
      this.setState({
        currentTab: parseInt(defaultTab, 10),
      })
    }
  }

  getTabs(nodes) {
    const tabs = []
    let i = 1

    for (const node of nodes) {
      tabs.push(node.props.title ? node.props.title : `Tab ${i}`)
      i++
    }

    return tabs
  }

  changeTab(tab) {
    const { onChange } = this.props

    this.setState({ currentTab: tab })

    if (typeof onChange === 'function') {
      onChange(tab)
    }
  }

  render() {
    const { className, children } = this.props

    const { currentTab } = this.state

    let nodes = children

    if (!Array.isArray(children)) {
      nodes = [children]
    }

    const tabs = this.getTabs(nodes)

    return (
      <div className={`nav-tab ${className || ''}`}>
        <div className='tab-headers'>
          {tabs.map((tab, k) => (
            <div
              className={`tab ${k === currentTab ? 'active' : ''}`}
              key={k}
              onClick={() => this.changeTab(k)}
            >
              <span>{tab}</span>
            </div>
          ))}
        </div>
        <div className='tab-contents'>
          {nodes.map((tab, k) => {
            if (React.isValidElement(tab)) {
              tab = React.cloneElement(tab, { visible: k === currentTab })
            }
            return <>{tab}</>
          })}
        </div>
      </div>
    )
  }
}

export default NavTab
export { NavTab }
